import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { useMutation } from "@/hooks/useMutation"
import { ref } from "vue"
import {
  ResendEmailConfirmationMutation,
  ResendEmailConfirmationMutationMutation,
  ConsultantProfile,
} from "@/gql"
import { useNotification } from "@/hooks/useNotification"
import useRouter from "@/router/useRouter"
import { useConsultantOnboardingChecklist } from "../hooks/useConsultantOnboardingChecklist"


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingCheckListCard',
  props: {
    consultant: null
  },
  setup(__props: any) {

const props = __props as {
  consultant: ConsultantProfile
}

const { routes } = useRouter()



const { mutate } = useMutation()
const { addSuccess } = useNotification()

const isSendingEmail = ref(false)

const { isUserVerified, hasReceivingAccount } = useConsultantOnboardingChecklist(props.consultant)

const onResendEmailConfirmation = async () => {
  isSendingEmail.value = true

  const result = await mutate<ResendEmailConfirmationMutationMutation>({
    mutation: ResendEmailConfirmationMutation,
    done: () => {
      isSendingEmail.value = false
    },
  })

  if (!result?.data?.resendEmailConfirmation.error) {
    addSuccess("Email confirmation sent")
  }
}

return { __sfc: true,routes, props, mutate, addSuccess, isSendingEmail, isUserVerified, hasReceivingAccount, onResendEmailConfirmation, Icon }
}

})